// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"40":"be282bd3e33c20e3","888":"cb386617e2f2275f"}[chunkId] + ".css";
};